
import { Box, Typography, useTheme, Link } from "@mui/material";
import { tokens } from "../../theme";

const Footer = () => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);

  return null;
};

export default Footer;
